export const NEW_TICKET = 'NEW_TICKET';
export const NEW_TICKET_INIT = 'NEW_TICKET_INIT';
export const NEW_TICKET_ERROR = 'NEW_TICKET_ERROR';
export const NEW_TICKET_CHANGE_POSITION_START = 'NEW_TICKET_CHANGE_POSITION_START';
export const NEW_TICKET_CHANGE_POSITION_STOP = 'NEW_TICKET_CHANGE_POSITION_STOP';
export const NEW_TICKET_CHANGE_POSITION = 'NEW_TICKET_CHANGE_POSITION';
export const NEW_TICKET_OPEN_MODAL = 'NEW_TICKET_OPEN_MODAL';
export const NEW_TICKET_CLOSE_MODAL = 'NEW_TICKET_CLOSE_MODAL';
